export class Metric {
  public key?: string;
  public numberOfSeconds?: number;
  public createdAt?: Date;

  constructor(obj: Metric = {} as Metric) {
    this.key = obj.key;
    this.numberOfSeconds = obj.numberOfSeconds;
    this.createdAt = obj.createdAt;
  }
}